angular.module('galilai.creator').controller('DesignController', function ($scope, $http, api, $timeout, parserService, fontsService, layoutService, $rootScope, animator, mediaService, visual, videoService) {
    console.log('DesignController');
    const MAX_VIDEO_DURATION_MINUTES = 3
    const ENABLE_ANIMATED = true
    const DEFAULT_SPEED_REELS = 320
    // TODO - Improve carousel default layouts
    const DEFAULTS_LAYOUTS = [
        'carousels.geometric.slide1.image-left-trapezoid',
        'carousels.geometric.slide1.image-right-trapezoid',
        'carousels.geometric.slide1.image-right-trapezoid-invert',
        'carousels.geometric.slide1.number-round',
        'carousels.geometric.slide1.number-round-invert',
        //'carousels.geometric.slide1.number-left',
        //'carousels.geometric.slide1.number-left-invert',
        'carousels.geometric.slide1.image-left-trapezoid',
        'carousels.geometric.slide1.image-left-trapezoid-invert',
        'carousels.simple-line.cover.number-round-align-left',
        'carousels.simple-line.cover.number-round-align-left-invert',
        'carousels.simple-line.cover.number-right-vline-invert',
        'inner.text-center-with-border',
        'inner.image-bottom',
    ]
    const modalSelector = "#layouts-modal"
    const modalMusicSelector = "#images-modal"
    const HISTORY_ENABLED = true
    let modalElement = null
    let modalMusicElement = null

    $scope.theme = getBaseTheme()
    const INITIAL_LAYOUTS_FOR_INDEX = {}

    $scope.content = {
        items: [],
        images: {},
        icons: {},
        overlays: {},
        global: {},
    }

    $scope.showTimerEdit = false;
    $scope.view = {
        videoMode: 'preview',
        renderKind: null,
        duration: 0,
        formattedDuration: '',
        fonts: ALL_GOOGLE_FONTS.map(function(font) {
            return {
                label: font,
                value: font
            }
        }),
    }

    $scope.timeline = {}

    $scope.visuals = {
        services: [],
        data: [],
        history: [],
    }

    let loadedLayoutsMap = {}
    let animators = {}
    let currentAnimator = animator()
    let intervalChange = null
    let modifiedCount = 0
    function changeCallback(newVal, oldVal) {
        if (modifiedCount++ <= 5) {
            return
        }
        if (oldVal == null || typeof oldVal == 'undefined') {
            return
        }
        if (intervalChange) {
            $timeout.cancel(intervalChange)
        }
        intervalChange = $timeout(function () {
            $rootScope.$broadcast('contentModified', {post: getPostData()})
        }, 300)
    }
    $scope.layouts = []
    $scope.parsedContent = {}
    $scope.extraInfo = {}
    $scope.allThemes = {}

    $scope.$watch('view.mediaFormat', changeCallback, true)
    $scope.$watch('format', changeCallback, true)
    $scope.$watch('theme', changeCallback, true)
    $scope.$watch('content', changeCallback, true)
    $scope.$watch('layouts', changeCallback, true)
    $scope.$watch('timeline', changeCallback, true)

    let debounceGenerate = null
    $rootScope.$watch('isGeneratingContent', function(newVal, oldVal) {
        if (debounceGenerate) {
            $timeout.cancel(debounceGenerate)
        }
        debounceGenerate = $timeout(function () {
            $scope.refreshTheme()
        }, 200)
    })

    function fixMediaFormat() {
        if ($scope.format == 'reels') {
            $scope.view.mediaFormat = 'video'
        } else if ($scope.format == 'post') {
            $scope.view.mediaFormat = 'image'
        }
    }
    $rootScope.$on('changeFormat', function(event, data) {
        if (data.format) {
            $scope.format = data.format
            fixMediaFormat()
            $scope.refreshTheme()
        }
    })


    window.addEventListener('message', function(event) {
        if (event.data.type == 'animation' && event.data.action == 'wait-setup') {
            videoService.checkAllVideosCached(function() {
                $scope.refreshTheme()
                $timeout(function() {
                    window.postMessage(
                        {
                            kind: 'response',
                            name: 'setup-ready',
                            id: event.data.id
                        }, '*');
                }, 500)
            })
        }
    })

    $rootScope.$on('animator.duration', function(event, data) {
        if (data.duration) {
            $scope.view.duration = data.duration/1000
            let minutes = Math.floor($scope.view.duration / 60)
            let seconds = $scope.view.duration - minutes * 60
            // if has minutes, do not show decimals for seconds, else show 1
            if (minutes > 0) {
                seconds = Math.floor(seconds)
            } else {
                seconds = seconds.toFixed(1)
            }

            $scope.view.formattedDuration = ''
            if (minutes > 0) {
                $scope.view.formattedDuration += minutes + 'm '
            }
            $scope.view.formattedDuration += seconds + 's'
        }
    })

    $rootScope.$on('changeTimeline', function(event, data) {
        if (data.timeline) {
            $scope.timeline = data.timeline
            $scope.refreshTheme()
        }
    })

    $rootScope.$on('changePostSize', function(event, data) {
        $scope.changePostSize(data.size)
    })

    $rootScope.postsAmount = 0

    function getPostData() {
        return {
            format: $scope.format,
            mediaFormat: $scope.view.mediaFormat,
            theme: $scope.theme,
            layouts: $scope.layouts,
            images: $scope.content.images,
            overlays: $scope.content.overlays,
            items: $scope.content.items,
            timeline: $scope.timeline,
            global: {
                content: $scope.content.global
            }
        }
    }

    $scope.setupModal = function() {
        modalElement = angular.element(modalSelector);
        modalMusicElement = angular.element(modalMusicSelector);
        $(modalSelector).on('hide.bs.modal', function (event) {

        });
    }

    $scope.showModal = function() {
        if (modalElement) {
            modalElement.modal("show");
        }
    }

    $scope.showModalLayout = function(index, kind) {
        showEditItem(index, kind)
    }

    $scope.showBrandingModal = function() {
        showEditItem(0, 'pallete', 'multiple')
    }

    $scope.changePostSize = function(size, source) {
        function applyChange() {
            let mapSizes = {
                'portrait': {
                    width: 1,
                    height: 1.25
                },
                'story': {
                    width: 1,
                    height: 1.777777777778
                },
            }
            $scope.theme.size = mapSizes[size]
            $scope.refreshTheme()
            $timeout(angular.noop)
        }
        let shouldBeTall = $scope.format == 'reels' || $scope.format == 'story'
        if (shouldBeTall && size != 'story' && source == 'user') {
            showConfirm(gettext('label.post_should_be_tall'), null, function(status) {
                if (status) {
                    applyChange()
                }
            })
        } else {
            applyChange()
        }
    }

    $scope.changePostType = function(type) {
        let mapSizes = {
            'reels': {
                width: 1,
                height: 1.777777777778
            },
            'story': {
                width: 1,
                height: 1.777777777778
            },
            'post': {
                width: 1,
                height: 1.25
            }
        }
        $scope.format = type
        $scope.theme.size = mapSizes[type]
        $scope.refreshTheme()
        fixMediaFormat()
        $timeout(angular.noop)
    }

    $scope.changeMediaFormat = function(type) {
        if (!$rootScope.isPremiumCustomer()) {
            $rootScope.showUpgrade('Select Video')
            return
        }
        $scope.view.mediaFormat = type
        $scope.changeVideoMode(type == 'video' ? 'preview' : 'edit')
    }

    $scope.changeVideoMode = function(type){
        function applyChange() {
            $scope.view.videoMode = type
            $scope.refreshTheme()
            $timeout(angular.noop)
        }

        if (type == 'preview') {
            $scope.waitForMediaLoading()
            .then(function() {
                applyChange()
            })
            .catch(function(err) {
                showError(gettext('error.generic'))
            })
            .finally(function() {
                $rootScope.isLoadingPost = true
            })
        } else {
            applyChange()
        }
    }

    $scope.shouldShowPreviewMessage = function() {
        return $scope.view.videoMode == 'preview' && $scope.hasVideos() && !$scope.view.renderKind
    }

    $scope.isTooLongVideo = function() {
        return $scope.view.duration >= MAX_VIDEO_DURATION_MINUTES * 60 && $scope.view.videoMode == 'preview' && !$scope.view.renderKind
    }
    $scope.getTooLongVideoMessage = function() {
        return gettext('label.too_long_video', MAX_VIDEO_DURATION_MINUTES)
    }

    $scope.changeSpeed = function() {
        $scope.view.videoMode = 'preview'
        $scope.refreshTheme()
    }

    $scope.isMediaVideo = function() {
        let isReels = $scope.format == 'reels'
        let isStoryAnimated = $scope.format == 'story' && $scope?.view?.mediaFormat == 'video'
        return isReels || isStoryAnimated
    }

    $scope.isAnimating = function() {
        return $scope.isMediaVideo() && $scope.view.videoMode == 'preview' && !$rootScope.isGeneratingContent
    }

    $scope.isSizeMedium = function() {
        return $scope.theme.size.height == 1.25
    }

    $scope.isSizeLarge = function() {
        return $scope.theme.size.height > 1.7
    }

    function showEditItem(index, kind, mode) {
        let base = $scope.content.global || {}
        let item = JSON.parse(JSON.stringify($scope.content.items[index]))
        item = Object.assign(JSON.parse(JSON.stringify(base)), item)

        if (!$rootScope.isCalendar()) {
            item.image = $scope.content.images[index]
            if ($scope.content.overlays && $scope.content.overlays.hasOwnProperty(index)) {
                item.overlays = $scope.content.overlays[index]
            }
        }

        let dynamicId = null
        if ($scope.layouts && $scope.layouts[0]) {
            dynamicId = getLayoutParentId($scope.layouts[0])
        }
        let layoutsInUse = $scope.layouts.map(function(layout) {
            return layout.label
        })

        layoutsInUse = Array.from(new Set(layoutsInUse))
        let editConfig = {
            item: item,
            layout: $scope.layouts[index],
            theme: $scope.theme,
            id: index,
            params: {
                layouts: layoutsInUse,
                dynamicId: dynamicId,
            }
        }
        if ($scope.fullPost && $scope.fullPost.meta && $scope.fullPost.meta.project) {
            editConfig.params.projectId = $scope.fullPost.meta.project
        }
        if ($scope.fullPost && $scope.fullPost.project) {
            editConfig.params.project = $scope.fullPost.project
        }
        if (kind) {
            editConfig.kind = kind
        }
        if (mode) {
            editConfig.params.mode = mode
        }
        $rootScope.$emit('editItem', editConfig)
        if ($rootScope.isCalendar()) {
            return
        }
        $scope.showModal();
    }

    $scope.selectMusic = function() {
        if (modalMusicElement) {
            modalMusicElement.modal('show')
            modalMusicElement.css('z-index', 100000)

            // TODO - Here
            let projectId = null
            if ($scope.fullPost && $scope.fullPost.meta && $scope.fullPost.meta.project) {
                projectId = $scope.fullPost.meta.project
            }
            $rootScope.$broadcast('media.show', {
                source: 'select-main-audio',
                projectId: projectId,
                kind: 'audio'
            })
        }
    }

    $scope.removeMusic = function() {
        delete $scope.timeline.main.audio
        $scope.refreshTheme()
        // UPdate post
    }

    $scope.previewMusic = function() {
        if (!$scope.timeline.main.audio.url) {
            return
        }
        mediaService.previewAudio({
            data: {
                url: $scope.timeline.main.audio.url
            }
        })
    }

    $scope.editItem = function(index, type) {
        if ($rootScope.isEditor()) {
            return
        }
        let source = 'Edit Item'
        if (type) {
            source = type + ' Item'
        }
        track('Editor Action Click', {
            source: source,
        })

        if (!$rootScope.isCustomer(showModal=true, source=source)) {
            return
        }
        if (type == 'Delete') {
            showConfirm(gettext('label.remove_generic'), null, function(status) {
                if (status) {
                    api.removePost($scope.content.items[index].serverId).then(function(response) {
                        $rootScope.$emit('loadPosts')
                    }).catch(function(err) {
                        showError(gettext('error.generic'))
                    })
                }
            })
            return
        }
        if (type == 'Duplicate') {
            let item = $scope.content.items[index]
            if (!item.serverId) {
                return
            }
            api.duplicatePost(item.serverId).then(function(response) {
                $rootScope.$emit('loadPosts')
                let canvasWrapper = document.querySelector('.canvas-wrapper')
                if (canvasWrapper) {
                    window.scrollTo(0, canvasWrapper.offsetTop)
                }
            }).catch(function(err) {
                showError(gettext('error.generic'))
            })
            return
        }
        showEditItem(index)
    }

    let debounceRefresh = null

    $scope.refreshThemeAtIndex = function(index) {
        $scope.refreshTheme()
        return
        // TODO - This is bugged
        $scope.refreshTheme({
            refreshAt: index,
        })
    }

    function getEditItem(index) {
        // TODO - Review
        //let base = $scope.content.global || {}
        //let item = JSON.parse(JSON.stringify($scope.content.items[index]))
        //item = Object.assign(JSON.parse(JSON.stringify(base)), item)
        let item = $scope.content.items[index]

        if (!$rootScope.isCalendar()) {
            item.image = $scope.content.images[index]
            if ($scope.content.overlays && $scope.content.overlays.hasOwnProperty(index)) {
                item.overlays = $scope.content.overlays[index]
            }
        }

        let dynamicId = null
        if ($scope.layouts && $scope.layouts[0]) {
            dynamicId = getLayoutParentId($scope.layouts[0])
        }
        if (!$scope.theme.settings) {
            $scope.theme.settings = {}
        }
        if (!$scope.theme.settings[index]) {
            $scope.theme.settings[index] = {}
        }
        let editConfig = {
            item: item,
            layout: $scope.layouts[index],
            theme: $scope.theme,
            id: index,
            params: {
                dynamicId: dynamicId,
            }
        }
        return editConfig
    }

    $scope.refreshTheme = function(data) {
        _d('Size items : ' + $scope.content.items.length)
        let hasItems = $scope.content && $scope.content.items && $scope.content.items.length > 0
        let hasParsedItems= $scope.parsedContent && $scope.parsedContent.items && $scope.parsedContent.items.length > 0
        if (!hasItems && !hasParsedItems) {
            return
        }

        _dstart('refresh theme')
        function refresh() {
            if (data && data.applySingle) {
                $scope.parsedContent.items[data.selectedItem.id] = parserService.convertLayout(
                    data.selectedItem.layout,
                    $scope.getContentForItem(data.selectedItem.item, data.selectedItem.id),
                    $scope.getThemeForItem(data.selectedItem, data.selectedItem.id),
                    {
                        mainId: 'design-' + data.selectedItem.id,
                    }
                )
            } else {
                function refreshAt(item, index) {
                    let specVideo = null
                    if ($scope.view.videoMode == 'preview') {
                        specVideo = {
                            size: $scope.view.renderKind? 'full' : 'small'
                        }
                    }
                    let globalParams = {
                        mainId: 'design-' + index,
                    }
                    if (specVideo) {
                        globalParams.video = specVideo
                    }
                    return parserService.convertLayout(
                        $scope.getLayoutForItem(item, index),
                        $scope.getContentForItem(item, index),
                        $scope.getThemeForItem(item, index),
                        globalParams,
                    );
                }
                if (data && data.refreshAt) {
                    if (!$scope.parsedContent.items[data.refreshAt]) {
                        $scope.parsedContent.items.push(refreshAt($scope.content.items[data.refreshAt], data.refreshAt))
                    } else {
                        $scope.parsedContent.items[data.refreshAt] = refreshAt($scope.content.items[data.refreshAt], data.refreshAt)
                    }
                } else {
                    $scope.parsedContent.items = $scope.content.items.map(refreshAt)
                }
            }
            _dend('refresh theme')

            $scope.initAnimation()

            $rootScope.isLoadingPost = false
            $timeout(angular.noop)

            $timeout(function() {
                $scope.initVisual()
            })
        }
        if (debounceRefresh) {
            $timeout.cancel(debounceRefresh)
        }
        debounceRefresh = $timeout(refresh, 300)
    }

    function individualPostsAnimation() {
        if (!ENABLE_ANIMATED) {
            return
        }
        function isIndexAnimated(index) {
            if ($scope.extraInfo && $scope.extraInfo[index] && $scope.extraInfo[index].format) {
                return $scope.extraInfo[index].format == 'reels'
            }
            let formats = ['post', 'reels', 'post']
            let format = chooseWithHash(formats, index)
            return format == 'reels' || index == 0
        }
        if ($rootScope.isGeneratingContent || $rootScope.generatingIndividualPosts) {
            return
        }
        for (activeAnimator in animators) {
            animators[activeAnimator].stop()
            delete animators[activeAnimator]
        }
        animators = {}
        for (let index in $scope.content.items) {
            if (!$scope.content.items[index].serverId) {
                return
            }
            if (!isIndexAnimated(index)) {
                continue
            }
            animators[index] = animator()
            animators[index].init([$scope.parsedContent.items[index]])

            animators[index].start('loop', {
                startDelay: 200,
                statusCb: function(err) {
                    if (err) {
                        logError({
                            message: 'Error running animation',
                            error: err
                        })
                    }
                }
            })
        }
    }

    $scope.hasVideos = function() {
        return $scope?.content?.images && $scope.content.images.filter(function(image) {
            if (typeof image == 'string') {
                return false
            }
            return image && image.full
        }).length > 0
    }

    $scope.waitForMediaLoading = function() {
        let videos = []
        for (let media of $scope.content.images) {
            if (typeof media == 'string') {
                continue
            }
            if (media && media.full) {
                let size = $scope.view.renderKind? 'full' : 'small'
                videos.push(media[size] || media.full)
            }
        }
        if (!videos.length) {
            return Promise.resolve()
        }
        if (videoService.hasPendingVideos(videos) && !$scope.view.renderKind) {
            $rootScope.isLoadingPost = true
        }
        return videoService.downloadAndWait(videos)
    }

    let deboundIndividualPostsAnimation = null
    $scope.initAnimation = function() {
        if (currentAnimator) {
            currentAnimator.stop()
        }
        // Calendar view
        if ($rootScope.isCalendar()) {
            if (deboundIndividualPostsAnimation) {
                $timeout.cancel(deboundIndividualPostsAnimation)
            }
            deboundIndividualPostsAnimation = $timeout(individualPostsAnimation, 1000)
            return
        }
        // Editor view
        if ($rootScope.isGeneratingContent) {
            return
        }
        let itemsToAnimate = $scope.parsedContent.items
        currentAnimator = animator()
        currentAnimator.init(itemsToAnimate, $scope.theme, {timeline: $scope.timeline})

        if ($scope.isAnimating() && currentAnimator.shouldAutoStart()) {
            let loopType = 'loop'
            currentAnimator.start(loopType, {
                startDelay: 200,
                statusCb: function() {
                    if (loopType == 'loop') {
                        return
                    }
                    $scope.refreshTheme()
                    $timeout(angular.noop)
                }
            })
        }
    }

    $scope.setupEvents = function() {
        $rootScope.$on('selectLayout', function(event, data) {

            try {
                if ($scope.theme.settings[data.selectedItem.id]) {
                    let settings = $scope.theme.settings[data.selectedItem.id]
                    let idsToDelete = []
                    if (settings.visual && settings.visual.elements) {
                        for (let key in settings.visual.elements) {
                            if (key.indexOf('overlay') === -1) {
                                idsToDelete.push(key)
                            }
                        }
                    }
                    for (let id of idsToDelete) {
                        delete settings.visual.elements[id]
                    }
                }
            } catch (e) {
                console.log('Error removing properties', e)
            }

            $scope.parsedContent.items[data.selectedItem.id] = parserService.convertLayout(data.layout, data.selectedItem.item, $scope.getThemeForItem(data.selectedItem, data.selectedItem.id))
            $scope.layouts[data.selectedItem.id] = data.layout
            $timeout(angular.noop)
            $scope.refreshTheme(data)
        })

        $rootScope.$on('selectPallete', function(event, data) {
            $scope.theme.pallete = data.pallete
            $scope.refreshTheme(data)
        })
        $rootScope.$on('updateSettings', function(event, data) {
            // LATER - Custom font size shouldn't overwrite
            $scope.theme.settings[data.selectedItem.id] = data.settings
            if (data.selectedItem && data.selectedItem.theme && data.selectedItem.theme.global) {
                $scope.theme.global = Object.assign({}, $scope.theme.global, data.selectedItem.theme.global)
            }
            $scope.refreshTheme(data)
        })
        $rootScope.$on('updateExtraInfo', function(event, data) {
            $scope.extraInfo = data.extraInfo
            $scope.refreshTheme()
        })
        $rootScope.$on('selectSizes', function(event, data) {
            $scope.theme.size = data.size
            $scope.refreshTheme(data)
        })

        $rootScope.$on('selectFonts', function(event, data) {
            $scope.theme.fonts = Object.assign($scope.theme.fonts, data.fonts)
            $scope.refreshTheme(data)
        })

        $rootScope.$on('selectImages', function(event, data) {
            if (!$scope.content.images) {
                $scope.content.images = []
            }
            $scope.content.images[data.selectedItem.id] = data.image
            $scope.refreshTheme(data)
        })

        $rootScope.$on('updateOverlays', function(event, data) {
            if (!$scope.content.overlays) {
                $scope.content.overlays = []
            }
            $scope.content.overlays[data.selectedItem.id] = data.overlays
            $scope.refreshTheme(data)
        })

        // TODO - above duplicated
        $rootScope.$on('selectBackgrounds', function(event, data) {
            if (!$scope.content.overlays) {
                $scope.content.overlays = []
            }
            $scope.content.overlays[data.selectedItem.id] = data.overlays
            $scope.refreshTheme(data)
        })

        $rootScope.$on('selectIcons', function(event, data) {
            $scope.content.icons[data.selectedItem.id] = data.icons
            $scope.refreshTheme(data)
        })

        $rootScope.$on('contentChanged', function(event, data) {
            // Make alternate layouts variation
            if ($scope.layouts && $scope.layouts.length > 0 && getLayoutParentId($scope.layouts[0])) {
                if (!$scope.theme.settings) {
                    $scope.theme.settings = {}
                }
                for (let i = 1; i < data.items.length; i++) {
                    if (typeof $scope.theme.settings[i] == 'undefined') {
                        $scope.theme.settings[i] = {}
                        $scope.theme.settings[i].invertColor = (i - 1) % 2 == 0
                    }
                }
            }

            // Improve mapping
            $scope.content.items = data.items.map(function(item) {
                let result = {
                    title: item.title,
                    number: item.number,
                    description: item.descriptions.length > 0 ? item.descriptions[0] : null,
                    image: item.images.length > 0 ? item.images[0] : null,
                    icons: item.icons
                }
                for (let key in specialAttributes) {
                    if (item[key]) {
                        result[key] = item[key]
                    }
                }
                return result
            })
            $scope.refreshTheme()
        })

        $rootScope.$on('themeChanged', function(event, data) {
            $scope.theme = data
            $scope.loadFonts()
            $scope.refreshTheme()
        })

        $rootScope.$on('globalChanged', function(event, data) {
            $scope.content.global = data.content
            $scope.refreshTheme()
        })

        $rootScope.$on('itemAdded', function(event, data, prepend=false) {
            let newItem = JSON.parse(JSON.stringify(data))
            // TASK [LP] Why settings not used?
            let settings = newItem.settings
            delete newItem.settings

            // LATER - index
            // TODO - Not bound (dynamic)
            let currentAddIndex = $scope.layouts.length
            try {
                if (data?.layout?.startsWith(SMART_LAYOUTS_PREFIX)) {
                    $scope.layouts[currentAddIndex] = layoutService.getExpandedLayout(data.layout)
                }
            } catch (e) {
                console.log('Error getting layout', e)
            }
            if (!$scope.layouts[currentAddIndex]) {
                $scope.layouts[currentAddIndex] = $scope.expandedLayouts.find(item => item.label === newItem.layout)
            }
            if (prepend) {
                $scope.content.items.unshift(newItem)
            } else {
                $scope.content.items.push(newItem)
            }

            let index = $scope.content.items.length - 1
            // LATER - Update settings
            $scope.refreshThemeAtIndex(index)
            $rootScope.postsAmount = $scope.content.items.length
        })

        $rootScope.$on('itemChanged', function(event, data) {
            $scope.content.items[data.id] = Object.assign($scope.content.items[data.id], data.changes)
            if (data.changes.image) {
                $scope.content.images[data.id] = data.changes.image
                // Remove dynamic image
                if ($scope.content.items[data.id].settings && $scope.content.items[data.id].setttings.dynamic) {
                    delete $scope.content.items[data.id].settings.dynamic
                }
            }
            if (typeof data.changes.image !='undefined' && data.changes.image == null) {
                $scope.content.images[data.id] = null
            }
            $scope.refreshThemeAtIndex(data.id)
        })

        function getDefaultMediaFormat(format) {
            if (format == 'reels') {
                return 'video'
            }
            return 'image'
        }

        $rootScope.$on('loadPost', function(event, data, fullPost) {
            let render = new URLSearchParams(window.location.search).get('renderKind')
            $scope.view.renderKind = render
            if (!render) {
                $scope.format = data.format
            } else {
                if (render == 'video') {
                    $scope.format = 'reels'
                } else {
                    $scope.format = 'post'
                }
            }

            $scope.view.mediaFormat = data.mediaFormat || getDefaultMediaFormat($scope.format)
            $scope.fullPost = fullPost
            $scope.theme = data.theme
            $scope.layouts = data.layouts
            $scope.content.images = data.images
            $scope.content.items = data.items
            $scope.content.overlays = data.overlays

            // Load videos
            if ($scope.hasVideos()) {
                $scope.view.videoMode = 'edit'
                if ($scope.view.renderKind == 'video') {
                    $scope.view.videoMode = 'preview'
                    $scope.waitForMediaLoading()
                }
            }
            if (data.global) {
                $scope.content.global = data.global.content
            }
            if (data.timeline) {
                $scope.timeline = data.timeline
            }
            if (!$scope.timeline) {
                $scope.timeline = {}
            }
            if (!$scope.timeline.main) {
                $scope.timeline.main = {}
            }
            if (!$scope.timeline.main.speed) {
                $scope.timeline.main.speed = DEFAULT_SPEED_REELS
            }
            if (data.extraInfo) {
                $scope.extraInfo = data.extraInfo
            } else {
                $scope.extraInfo = {}
            }
            if (data.allThemes) {
                $scope.allThemes = data.allThemes
            } else {
                $scope.allThemes = {}
            }
            $scope.loadFonts();
            $scope.refreshTheme()

            if (data.layouts && data.layouts.length > 0) {
                $scope.loadLayoutChildren(data.layouts[0])
            }
        })

        $rootScope.$on('loadLayoutChildren', function(event, data) {
            $scope.loadLayoutChildren(data.layout)
        })

        $scope.loadLayoutChildren = function(layout, cb) {
            let parentId = getLayoutParentId(layout)
            if (!parentId) {
                return
            }
            let params = {
                kind: 'children',
                parentId: parentId
            }
            layoutService.list(params).then(function(layouts) {
                let layoutsConfig = JSON.parse(JSON.stringify(layouts))
                for (let layoutKey in layoutsConfig.layouts) {
                    if (loadedLayoutsMap[layoutKey]) {
                        continue
                    }
                    loadedLayoutsMap[layoutKey] = true
                    for (layout of layoutService.expand(layoutsConfig.layouts[layoutKey], layoutKey, layoutsConfig.layouts)) {
                        $scope.expandedLayouts.push(layout)
                    }
                }

                if (cb) {
                    cb()
                }
            })
            .catch(function(err) {
                logError({
                    message: 'Error getting layouts',
                    error: err,
                })
            })
        }

        $rootScope.$on('getPost', function(event, data) {
            $rootScope.$emit('postData', {
                input: data,
                post: getPostData()
            })
        })

        $rootScope.$on('clearPosts', function(event, data) {
            $scope.layouts = []
            $scope.content.images = []
            $scope.content.items = []
            $scope.content.overlays = []
            $scope.theme.settings = {}
            $scope.refreshTheme()
        })

        $rootScope.$on('saveAll', function(event, data) {
            $scope.saveAllImagesToZip(data)
        })
    }

    function getDefaultLayout(item) {
        let defaultLayouts = DEFAULTS_LAYOUTS;
        let availableLayouts = $scope.expandedLayouts.filter(layoutItem => defaultLayouts.includes(layoutItem.label))
        .filter(function(layoutItem) {
            return layoutService.filter(layoutItem, item)
        })

        return availableLayouts[Math.floor(Math.random() * availableLayouts.length)]
    }
    function getDynamicLayoutChildren(index, item) {
        let selected = null
        try {
            let coverLayout = $scope.layouts[0].label
            let parentId = coverLayout.split('.')[0]

            function findLayoutsByObjective(objective) {
                return $scope.expandedLayouts.filter(layoutItem => layoutItem.label.startsWith(parentId) && layoutItem.label != coverLayout && layoutItem.classification && layoutItem.classification.objective == objective)
            }

            function findLayoutsSameParent() {
                return $scope.expandedLayouts.filter(layoutItem => layoutItem.label.startsWith(parentId) && layoutItem.label != coverLayout)
            }

            let orderFilter = [
                'page_item',
                'cover'
            ]
            let layoutChildren = []
            for (let objective of orderFilter) {
                layoutChildren = findLayoutsByObjective(objective)
                if (layoutChildren.length > 0) {
                    break
                }
            }

            if (!layoutChildren.length) {
                layoutChildren = findLayoutsSameParent()
            }

            selected = layoutChildren[(index - 1) % layoutChildren.length]
        } catch (e) {
            console.log('Error', e)
        }
        if (!selected) {
            return getDefaultLayout(item)
        }
        return selected
    }

    $scope.getLayoutForItem = function(item, index) {
        if (item.layout) {
            let foundLayout = $scope.expandedLayouts.find(layoutItem => layoutItem.label === item.layout)
            if (foundLayout) {
                $scope.layouts[index] = foundLayout
            }
        }
        if (!$scope.layouts[index]) {
            let hasDynamicLayout = false
            if ($scope.layouts[0] && getLayoutParentId($scope.layouts[0])) {
                hasDynamicLayout = true
            }
            // TODO - apply children theme layout
            if (INITIAL_LAYOUTS_FOR_INDEX[index]) {
                $scope.layouts[index] = $scope.expandedLayouts.find(layoutItem => layoutItem.label === INITIAL_LAYOUTS_FOR_INDEX[index])
            } else if (hasDynamicLayout) {
                $scope.layouts[index] = getDynamicLayoutChildren(index, item)
            } else {
                $scope.layouts[index] = getDefaultLayout(item)
            }
        }
        return $scope.layouts[index]
    }

    $scope.applyThemeToAllPages = function() {
        for (let i = 1; i < $scope.layouts.length; i++) {
            let selectedLayout = getDynamicLayoutChildren(i)
            let parentSelected = getLayoutParentId(selectedLayout)
            let currentParent = getLayoutParentId($scope.layouts[i])
            if (parentSelected == currentParent) {
                continue
            }
            $scope.layouts[i] = selectedLayout
        }
        $scope.refreshTheme()
    }

    $rootScope.$on('applyThemeToAllPages', function(event, data) {
        if (!getLayoutParentId(data.layout)) {
            return
        }
        $scope.loadLayoutChildren(data.layout, function() {
            $timeout(angular.noop)
            $scope.applyThemeToAllPages()
        })
    })

    $rootScope.$on('applyLayoutMultiplePages', function(event, data) {
        let selectedLayout = data.layout
        let pages = data.pages
        let page = data.page
        if (pages == 'all') {
            pages = Array.from({length: $scope.content.items.length}, (v, k) => k)
        }
        if (pages == 'odd') {
            pages = Array.from({length: $scope.content.items.length}, (v, k) => k).filter(function(value, index) {
                return index % 2 == 0
            })
        }
        if (pages == 'even') {
            pages = Array.from({length: $scope.content.items.length}, (v, k) => k).filter(function(value, index) {
                return index % 2 != 0
            })
        }
        if (pages == 'onwards') {
            pages = Array.from({length: $scope.content.items.length}, (v, k) => k).filter(function(value, index) {
                return index >= page
            })
        }
        if (pages == 'backwards') {
            pages = Array.from({length: $scope.content.items.length}, (v, k) => k).filter(function(value, index) {
                return index <= page
            })
        }

        for (let i of pages) {
            $scope.layouts[i] = selectedLayout
        }
        $scope.refreshTheme()
    })

    // LATER - Fix duplicate code
    $scope.getThemeForItem = function(item, index) {
        let theme = $scope.theme
        if ($scope.allThemes && $scope.allThemes.hasOwnProperty(index)) {
            theme = $scope.allThemes[index]
            // When all themes is used, use the first index
            index = 0
        }
        theme = parserService.getThemeForItem(theme, item, index)
        return theme
    }

    $scope.getContentForItem = function(item, index) {
        let base = $scope.content.global || {}
        item = Object.assign(JSON.parse(JSON.stringify(base)), item)
        if ($scope.content.images && $scope.content.images.hasOwnProperty(index)) {
            item.image = $scope.content.images[index]
        } else if (!(item.image && item.image.indexOf('.gif'))) { // TASK [HP] Improve
            item.image = null
        }
        if ($scope.content.icons && $scope.content.icons.hasOwnProperty(index)) {
            item.icons = $scope.content.icons[index]
        }
        if ($scope.content.overlays && $scope.content.overlays.hasOwnProperty(index)) {
            item.overlays = $scope.content.overlays[index]
        }
        return item
    }

    $scope.loadFonts = function() {
        let fontsToLoad = []
        if (!$scope.theme || !$scope.theme.fonts) {
            return
        }
        if ($scope.theme.fonts.primary) {
            fontsToLoad.push($scope.theme.fonts.primary)
        }
        if ($scope.theme.fonts.secondary) {
            fontsToLoad.push($scope.theme.fonts.secondary)
        }

        if ($scope.theme && $scope.theme.settings) {
            for (let index in $scope.theme.settings) {
                let settings = $scope.theme.settings[index]
                if (settings && settings.visual && settings.visual.elements) {
                    for (let key in settings.visual.elements) {
                        let element = settings.visual.elements[key]
                        if (element['font-family']) {
                            fontsToLoad.push(element['font-family'])
                        }
                    }
                }
            }
        }
        fontsService.load(fontsToLoad)
    }

    $scope.init = function() {
        console.log('Init Design')
        $scope.setupModal();
        $scope.setupEvents();

        _dstart('building design layouts')
        $scope.loadFonts();
        // Also load children
        layoutService.list().then(function(layouts) {
            $scope.layoutsConfig = JSON.parse(JSON.stringify(layouts))
            $scope.expandedLayouts = []
            // TASK [HP] Performance this is slow
            let start = performance.now()
            // TASK [HP] This is duplicated
            for (let layoutKey in $scope.layoutsConfig.layouts) {
                if (loadedLayoutsMap[layoutKey]) {
                    continue
                }
                loadedLayoutsMap[layoutKey] = true
                for (layout of layoutService.expand($scope.layoutsConfig.layouts[layoutKey], layoutKey, $scope.layoutsConfig.layouts)) {
                    $scope.expandedLayouts.push(layout)
                }
            }
            track('Metric Layout Build', {
                source: 'design',
                count: $scope.expandedLayouts.length,
                time: (performance.now() - start)
            })
            $scope.parsedContent.items = $scope.content.items.map(function(item, index) {
                // LATER - Refactor (duplicated)
                return parserService.convertLayout(
                    $scope.getLayoutForItem(item, index),
                    $scope.getContentForItem(item, index),
                    $scope.getThemeForItem(item, index)
                );
            })
            _dend('building design layouts')
        })
        .catch(function(err) {
            logError({
                message: 'Error getting layouts',
                error: err,
            })
        })
    }

    $scope.doAction = function(action) {
        $rootScope.$broadcast('doAction', action)
    }

    /* Visual actions */

    function getVisualData(index) {
        if ($scope.visuals.data[index]) {
            return $scope.visuals.data[index]
        }
        $scope.visuals.data[index] = {}
        return $scope.visuals.data[index]
    }

    $scope.isRender = function() {
        let render = new URLSearchParams(window.location.search).get('renderKind')
        return typeof render != 'undefined' && render != null && render != ''
    }

    $scope.initVisual = function() {
        if ($scope.isRender() || $scope.isAnimating() || !$scope.fullPost) {
            return
        }
        for (let visualItem of $scope.visuals.services) {
            visualItem.destroy()
        }
        $scope.visuals.services = []
        $scope.visuals.data = []

        for (item in $scope.content.items) {
            let editConfig = getEditItem(item)
            $scope.visuals.services[item] = new visual({
                id: item,
            })
            initHistory(item)
            $scope.visuals.services[item].init({
                select: function(element) {
                    getVisualData(this.id).selected = element
                    $timeout(angular.noop)
                },
                deselect: function(element) {
                    getVisualData(this.id).selected = null
                    $timeout(angular.noop)
                },
                onHistory: function() {
                    saveHistory(this.id)
                },
                update: function(change) {
                    let selectedItem = $scope.content.items[this.id]
                    if (!selectedItem) {
                        return
                    }
                    let isTextChange = false
                    if (change && change.values && change.values.content && selectedItem && selectedItem.overlays && selectedItem.overlays.elements) {
                        // Find element within overlay and update its value witht content
                        let overlayElements = selectedItem.overlays.elements
                        let element = overlayElements.find(function(element) {
                            return element.uniqueId == change.elementId
                        })
                        if (element) {
                            element.value = change.values.content
                            isTextChange = true
                        }
                    }
                    saveHistory(this.id, isTextChange)
                    $timeout(angular.noop)
                },
                render: function(params) {
                    $scope.refreshVisual(params.currentItem)
                }
            }, editConfig, {
                wrapperSelector: '[container-id="design-' + item + '"]',
            })
            $scope.visuals.data[item] = {}
        }
    }

    $scope.refreshVisual = function(selectedItem) {
        $timeout(function() {
            let item = selectedItem.item
            if (item?.image) {
                if (!$scope.content.images) {
                    $scope.content.images = []
                }
                $scope.content.images[selectedItem.id] = item.image
            }

            if (item?.overlays) {
                if (!$scope.content.overlays) {
                    $scope.content.overlays = []
                }
                $scope.content.overlays[selectedItem.id] = item.overlays
            }

            $scope.refreshTheme()
        })
    }

    function getVisual(index) {
        return $scope.visuals.services[index]
    }

    $scope.doVisualAction = function(index, $event, action, ...args) {
        let visual = getVisual(index)
        if (!visual) {
            return
        }

        if (action == 'addText') {
            visual.addText('h1', gettext('label.my_text'))
        }
        if (action == 'remove') {
            try {
                let item = visual.getElementById($scope.parsedContent.items[index].elements, visual.getSelectedElement().elementId)
                if (item?.video) {
                    // TODO - hardcoded
                    $scope.content.images[index] = null
                    $scope.content.items[index].image = null
                }

            } catch (e) {
                console.log('Error', e)
            }
            visual.removeElement()
        }
        if (action == 'replaceImage') {
            try {
                let item = visual.getElementById($scope.parsedContent.items[index].elements, visual.getSelectedElement().elementId)
                if (item?.video) {
                    $scope.showMediaSelector({name: 'replaceVideo', index: index, element: visual.getSelectedElement()}, 'video')
                    return
                }
            } catch (e) {
                console.log('Error', e)
            }
            $scope.showMediaSelector({name: 'replaceImage', index: index, element: visual.getSelectedElement()}, 'image')
        }
        if (action == 'customFont') {
            $scope.showMediaSelector({name: 'customFont', index: index, element: visual.getSelectedElement()}, 'font')
        }
        if (action == 'reset') {
            showConfirm(gettext('label.confirm_reset_layout'), null, function(status) {
                if (status) {
                    $scope.resetVisualLayout(index)
                }
            })
        }
        if (action == 'editLayouts') {
            showEditItem(index, 'layout', 'single')
        }
        if (action == 'editStyle') {
            showEditItem(index, 'layout', 'single')
        }
        if (action == 'formatText') {
            $event.preventDefault()
            $event.stopPropagation()
            visual.formatText(args[0])
        }
        if (action == 'alignText') {
            $event.preventDefault()
            $event.stopPropagation()
            visual.alignText(args[0])
        }
        if (action == 'addImage') {
            $scope.showMediaSelector({name: 'createImage', index: index}, 'image')
        }
        if (action == 'addVideo') {
            $scope.showMediaSelector({name: 'createVideo', index: index}, 'video')
        }
        if (action == 'addElements') {
            $scope.showMediaSelector({name: 'createIcons', index: index}, 'elements')
        }
        if (action == 'bringForward') {
            $event.preventDefault()
            $event.stopPropagation()
            visual.moveUp()
        }
        if (action == 'sendBackward') {
            $event.preventDefault()
            $event.stopPropagation()
            visual.moveDown()
        }
        if (action == 'undo') {
            undoHistory(index)
        }
        if (action == 'redo') {
            redoHistory(index)
        }
        if (action == 'editBrand') {
            showEditItem(index, args[0], 'multiple')
        }

        if (action == 'toggleHideOverlay') {
            $event.preventDefault()
            $event.stopPropagation()
            visual.toggleHideOverlay()
        }
    }

    function saveHistory(index, debounce) {
        if (!HISTORY_ENABLED) {
            return
        }
        let settings = $scope.theme.settings[index]
        let item = $scope.content.items[index]

        let history = {
            settings: settings,
            item: item,
        }
        if (!$scope.visuals.history[index]) {
            $scope.visuals.history[index] = new HistoryManager(history)
        } else {
            $scope.visuals.history[index].add(history, debounce)
        }
    }

    function initHistory(index) {
        if ($scope.visuals.history[index]) {
            return
        }
        saveHistory(index)
    }


    function undoHistory(index) {
        let history = $scope.visuals.history[index]
        if (!history) {
            return
        }
        history.undo()
        let state = history.getState()
        if (!state) {
            return
        }
        $scope.theme.settings[index] = state.settings
        $scope.content.items[index] = state.item
        if (!$scope.content.images) {
            $scope.content.images = {}
        }
        $scope.content.images[index] = state.item.image
        if (!$scope.content.overlays) {
            $scope.content.overlays = {}
        }
        $scope.content.overlays[index] = state.item.overlays
        $scope.refreshTheme()
    }

    function redoHistory(index) {
        let history = $scope.visuals.history[index]
        if (!history) {
            return
        }
        history.redo()
        let state = history.getState()
        if (!state) {
            return
        }
        $scope.theme.settings[index] = state.settings
        $scope.content.items[index] = state.item
        if (!$scope.content.images) {
            $scope.content.images = {}
        }
        $scope.content.images[index] = state.item.image
        if (!$scope.content.overlays) {
            $scope.content.overlays = {}
        }
        $scope.content.overlays[index] = state.item.overlays

        $scope.refreshTheme()
    }

    $scope.resetVisualLayout = function($index) {
        let visual = getVisual($index)
        if (!visual) {
            return
        }
        let ids = []
        let selectedItem = $scope.content.items[$index]
        if (selectedItem.overlays && selectedItem.overlays.elements) {
            selectedItem.overlays.elements.forEach(function(element) {
                ids.push(element.uniqueId)
            })
        }
        visual.resetVisualLayout($scope.theme, $index, {
            'exclude': ids
        })
        // TODO - Remove orphans
        $scope.refreshTheme()
    }

    $scope.showMediaSelector = function(source, kind) {
        let mediaModalElement = angular.element('#images-modal');
        if (mediaModalElement) {
            mediaModalElement.modal('show')
            mediaModalElement.css('z-index', 100000)

            if (typeof source == 'string') {
                source = {
                    name: source,
                }
            }
            source.origin = 'design'

            $rootScope.$broadcast('media.show', {
                source: source,
                projectId: $scope.fullPost?.meta?.project,
                kind: kind || 'image',
                customAction: source && source.name == 'createImage' ? 'create-or-replace': null,
            })
        }
    }

    $rootScope.$on('media.selected', function(event, medias, source, actionType) {
        if (source == 'select-main-audio') {
            $scope.view.mediaFormat = 'video'
        }
        if (source && source.origin != 'design') {
            return
        }
        if (source?.name == 'createVideo') {
            let index = source.index

            if (!$scope.content.images) {
                $scope.content.images = []
            }
            let media = medias[0]
            $scope.content.images[index] = {
                full: media.url,
                small: media.small,
                thumb: media.thumb,
            }
            $scope.refreshTheme()

            $scope.view.mediaFormat = 'video'
        }
        if (source?.name == 'replaceVideo') {
            let index = source.index
            getVisual(index).selectElement(source.element)
            $timeout(function() {
                let media = medias[0]
                $scope.content.images[index] = {
                    full: media.url,
                    small: media.small,
                    thumb: media.thumb,
                }
                $scope.refreshTheme()
            })
        }
        if (source?.name == 'createImage') {
            let index = source.index

            if (actionType == 'replace') {
                if (!$scope.content.images) {
                    $scope.content.images = []
                }
                $scope.content.images[index] = medias[0].url
                $scope.refreshTheme()
            } else {
                getVisual(index).addImage(medias[0].url)
            }
        }
        if (source?.name == 'createIcons') {
            let index = source.index
            if (medias[0].svg_url) {
                $http.get(medias[0].svg_url).then(function(response) {
                    getVisual(index).addElement(response.data)
                }).catch(function() {
                    console.log('Error loading SVG')
                })
            } else {
                getVisual(index).addElement(medias[0].url)
            }
        }
        if (source?.name == 'replaceImage') {
            let index = source.index
            getVisual(index).selectElement(source.element)
            $timeout(function() {
                getVisual(index).replaceImage(medias[0].url)
            })
        }

        if (source?.name == 'customFont') {
            let index = source.index
            getVisual(index).selectElement(source.element)
            $timeout(function() {
                let fontName = medias[0].url.split('/').pop()
                getVisual(index).replaceFont(fontName)
            })
        }

    })
});

